module.exports = __webpack_public_path__ + "static/media/education-cluster.909fec94.svg";